import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = {
  // Stations
  getStations: (params = {}) => axios.get(`${API}/stations`, { params, withCredentials: true }),
  getStation: (id) => axios.get(`${API}/stations/${id}`, { withCredentials: true }),
  trackStationClick: (id) => axios.post(`${API}/stations/${id}/click`, {}, { withCredentials: true }),
  createStation: (data) => axios.post(`${API}/stations`, data, { withCredentials: true }),
  updateStation: (id, data) => axios.put(`${API}/stations/${id}`, data, { withCredentials: true }),
  deleteStation: (id) => axios.delete(`${API}/stations/${id}`, { withCredentials: true }),

  // Favorites
  getFavorites: () => axios.get(`${API}/favorites`, { withCredentials: true }),
  addFavorite: (stationId) => axios.post(`${API}/favorites/${stationId}`, {}, { withCredentials: true }),
  removeFavorite: (stationId) => axios.delete(`${API}/favorites/${stationId}`, { withCredentials: true }),

  // Comments
  getComments: (stationId) => axios.get(`${API}/stations/${stationId}/comments`, { withCredentials: true }),
  createComment: (stationId, content) => axios.post(`${API}/stations/${stationId}/comments`, { content }, { withCredentials: true }),
  deleteComment: (commentId) => axios.delete(`${API}/comments/${commentId}`, { withCredentials: true }),
  likeComment: (commentId) => axios.post(`${API}/comments/${commentId}/like`, {}, { withCredentials: true }),
  unlikeComment: (commentId) => axios.delete(`${API}/comments/${commentId}/like`, { withCredentials: true }),

  // Users
  getUserProfile: (username) => axios.get(`${API}/users/${username}`, { withCredentials: true }),
  updateProfile: (data) => axios.put(`${API}/users/me`, data, { withCredentials: true }),
  searchUsers: (q = '', limit = 30) => axios.get(`${API}/users/search`, { params: { q, limit }, withCredentials: true }),
  followUser: (username) => axios.post(`${API}/users/${username}/follow`, {}, { withCredentials: true }),
  unfollowUser: (username) => axios.delete(`${API}/users/${username}/follow`, { withCredentials: true }),

  // Friend Requests
  sendFriendRequest: (targetUserId) => axios.post(`${API}/friend-requests/${targetUserId}`, {}, { withCredentials: true }),
  getIncomingFriendRequests: () => axios.get(`${API}/friend-requests/incoming`, { withCredentials: true }),
  getOutgoingFriendRequests: () => axios.get(`${API}/friend-requests/outgoing`, { withCredentials: true }),
  acceptFriendRequest: (requestId) => axios.post(`${API}/friend-requests/${requestId}/accept`, {}, { withCredentials: true }),
  rejectFriendRequest: (requestId) => axios.post(`${API}/friend-requests/${requestId}/reject`, {}, { withCredentials: true }),

  // Friends
  getFriends: () => axios.get(`${API}/friends`, { withCredentials: true }),

  // Notifications
  getNotifications: (params = {}) => axios.get(`${API}/notifications`, { params, withCredentials: true }),
  markNotificationRead: (notificationId) => axios.post(`${API}/notifications/${notificationId}/read`, {}, { withCredentials: true }),
  markAllNotificationsRead: () => axios.post(`${API}/notifications/read-all`, {}, { withCredentials: true }),

  // Admin
  adminGetStations: () => axios.get(`${API}/admin/stations`, { withCredentials: true }),
  adminGetComments: () => axios.get(`${API}/admin/comments`, { withCredentials: true }),
  adminGetUsers: () => axios.get(`${API}/admin/users`, { withCredentials: true }),

  // Metadata
  getGenres: () => axios.get(`${API}/genres`, { withCredentials: true }),
  getCountries: () => axios.get(`${API}/countries`, { withCredentials: true }),
};